import {
  useSidebarOpenState,
} from '@backstage/core-components';
import { ButtonIcon } from '@backstage/ui';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';

import { makeStyles } from '@material-ui/core';


const useSidebarStyles = makeStyles({

  customExpandButton: {
    padding: '8px',
    backgroundColor: 'var(--arla-sidebar-expand-button-background)',
    color: 'var(--bui-white)',
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.1)',
    },
  }
});

export const CustomSidebarExpandButton = () => {
  const classes = useSidebarStyles();
  const { isOpen, setOpen } = useSidebarOpenState();

  return (
    <div style={{ marginLeft: isOpen ? '22px' : '-12px' }}>
      <ButtonIcon
        aria-label={isOpen ? 'Collapse Sidebar' : 'Expand Sidebar'}
        onClick={() => setOpen(!isOpen)}
        className={classes.customExpandButton}
        icon={isOpen ? <ChevronLeft /> : <ChevronRight />}
      />
    </div>
  );
};